import { type IWithPopoverProps, WithPopover } from '@procurify/ui'

import { type UserLike } from '@webapp/core/interfaces/components/UserLike'
import { WithApprovalPoolTooltipContent } from './WithApprovalPoolTooltipContent'

export interface IWithApprovalPoolTooltipProps
  extends Partial<IWithPopoverProps> {
  /** The members belonging to the approval pool */
  members: UserLike[]
  /** Whether the tooltip should be prevented from showing up on hover */
  disabled?: boolean
}

export const WithApprovalPoolTooltip = ({
  members,
  children,
  trigger = 'hover',
  placement = 'top',
  disabled = false,
  open,
}: IWithApprovalPoolTooltipProps) => {
  return (
    <WithPopover
      content={<WithApprovalPoolTooltipContent members={members} />}
      placement={placement}
      trigger={trigger}
      disableHoverListener={disabled}
      open={open}
    >
      {children}
    </WithPopover>
  )
}
